import { Box } from '@mui/material';
import styled from 'styled-components';

export const LogoWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 2.5rem;
  max-height: 2.5rem;
  width: auto;

  svg {
    min-height: inherit;
    max-height: inherit;
    width: auto;
    object-fit: contain; /* Ensures the aspect ratio is preserved */
  }
`;
